"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TabListItem: ()=>TabListItem,
    PanelTabsHeader: ()=>PanelTabsHeader
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const tabs_namespaceObject = require("@base-ui-components/react/tabs");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../Tooltip/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_Tabs_variants_cjs_namespaceObject = require("./Tabs.variants.cjs");
function TabListItem({ disabled, iconLeft, iconRight, iconSize, label, helperText, value, labelProps, helperTextProps, tabClass, emphasis = 'regular' }) {
    const { tabLabelContent, tab } = (0, external_Tabs_variants_cjs_namespaceObject.tabsVariants)({
        emphasis
    });
    const tabClasses = (0, external_utils_index_cjs_namespaceObject.cn)(tab(), tabClass);
    const renderIcon = (side)=>{
        if ('left' === side && void 0 === iconLeft || null === iconLeft) return;
        if ('right' === side && void 0 === iconRight || null === iconRight) return;
        const icon = 'left' === side ? iconLeft : iconRight;
        if ('string' == typeof icon && index_cjs_namespaceObject.validGoogleSymbols.includes(icon)) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
            iconName: icon,
            size: iconSize
        });
        if (/*#__PURE__*/ (0, external_react_namespaceObject.isValidElement)(icon) && 'string' != typeof icon && 'number' != typeof icon) return icon;
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(tabs_namespaceObject.Tabs.Tab, {
        className: tabClasses,
        value: value,
        disabled: disabled,
        children: [
            renderIcon('left'),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: tabLabelContent(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                        textStyle: "body2",
                        ...labelProps,
                        children: label
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                        textStyle: "body3",
                        ...helperTextProps,
                        children: helperText
                    })
                ]
            }),
            renderIcon('right')
        ]
    });
}
function PanelTabsHeader({ tabsContent, defaultValue, tabClass, emphasis }) {
    return tabsContent.map((tabContent)=>{
        const { disabled, iconLeft, iconRight, iconSize = '20', label, helperText, value, labelProps, helperTextProps, tooltipProps } = tabContent;
        const TabItemProps = {
            defaultValue,
            disabled,
            iconLeft,
            iconRight,
            iconSize,
            label,
            helperText,
            value,
            labelProps,
            helperTextProps,
            tabClass,
            emphasis
        };
        if (tooltipProps) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
            emphasis: true,
            className: "data-disabled:cursor-not-allowed test cursor-pointer",
            triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TabListItem, {
                ...TabItemProps
            }),
            ...tooltipProps
        }, value);
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TabListItem, {
            ...TabItemProps
        }, value);
    });
}
exports.PanelTabsHeader = __webpack_exports__.PanelTabsHeader;
exports.TabListItem = __webpack_exports__.TabListItem;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "PanelTabsHeader",
    "TabListItem"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
